module.exports = __webpack_public_path__ + "img/9.b2f7f25c.jpg";